import Box from '@mui/material/Box'
import Tooltip from '@mui/material/Tooltip'
import DragIndicatorIcon from '@mui/icons-material/DragIndicator'

/**
 * The grip that says a row moves.
 *
 * It is drawn at rest rather than on hover, for the reason the row menu
 * is: an affordance nobody can see is not one. The row itself carries
 * the drag handlers — dragging by the grip alone is a narrower target
 * and the text of a row is the natural thing to grab — so this is a
 * *sign*, and the tooltip only elaborates.
 *
 * Reordering stays reachable without a pointer: the same command is an
 * item in the row's menu. A control that only exists as a drag is one
 * nobody on a keyboard can send, and the intent behind it is the same
 * either way.
 */
export function DragHandle({ label, disabled }: { label: string; disabled?: boolean }) {
  return (
    <Tooltip title={disabled ? 'Nothing to reorder here.' : `${label} — drag this row, or use its menu.`}>
      <Box
        component="span"
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          color: disabled ? 'action.disabled' : 'text.disabled',
          cursor: disabled ? 'default' : 'grab',
          '&:active': { cursor: disabled ? 'default' : 'grabbing' },
        }}
      >
        <DragIndicatorIcon fontSize="small" />
      </Box>
    </Tooltip>
  )
}
